import { parseDateValue } from '@/utils/dates'

/**
 * The borrower live page's clock.
 *
 * "Submitted" and "With us" read the deal's creation timestamp and the
 * server's days-open counter, both of which start when the platform ingested
 * the package. 45 Park Ave's package arrived on 3 Aug 2026 and was ingested on
 * 26 Sep, so the page said "Submitted Sep 26, 2026 · With us 0 days" beside a
 * file list dated Aug 3 (nd3-40). The deal's Received date (`originated`, the
 * catalogue's "Date Received") is when the borrower submitted.
 */
type TimelineDeal = {
  originated?: string | null
  createdAt?: string | null
  stage?: string | null
  fundedAt?: string | null
  totalDaysOpen?: number | null
}

const DAY_MS = 86_400_000

export function borrowerSubmitted(deal: TimelineDeal): string | null {
  const received = deal.originated?.trim()
  return received || deal.createdAt || null
}

/** Whole calendar days from submission to today (or to funding). */
export function daysWithUs(deal: TimelineDeal, now: Date = new Date()): number | null {
  const received = parseDateValue(deal.originated?.trim() || null)
  if (!received) return deal.totalDaysOpen ?? null
  const funded = deal.stage === 'Funded' ? parseDateValue(deal.fundedAt) : null
  const end = funded ?? now
  const startDay = Date.UTC(received.getFullYear(), received.getMonth(), received.getDate())
  const endDay = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate())
  return Math.max(0, Math.round((endDay - startDay) / DAY_MS))
}
